export enum LocationSearchModeEnum {
    CityState = 1,
    CityStatePostalCode = 2,
}
